import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import isNil from 'lodash/isNil'

type ProductPriceProps = {
  listPrice: number | null
  sellingPrice: number | null
  showLabels: boolean
  showStartingAt: any
  showSavings: any
  showListPrice: boolean | undefined
  unavailable: boolean
  currency: any
  installments: never[]
}

export const ProductPrice = ({
  currency,
  showListPrice,
  unavailable,
  sellingPrice,
  listPrice,
  showLabels,
  showStartingAt,
  showSavings,
}: ProductPriceProps) => {
  const intl = useIntl()

  if ((showListPrice && isNil(listPrice)) || isNil(sellingPrice)) {
    return null
  }

  if (unavailable) {
    return (
      <Text tone="secondary">
        <FormattedMessage id="searchResultUnavailable" />
      </Text>
    )
  }

  const differentPrices = showListPrice && sellingPrice !== listPrice

  return (
    <div>
      {differentPrices && (
        <div>
          {showLabels && (
            <div>
              <FormattedMessage id="pricing-from" />
            </div>
          )}
          <span>
            {/* // TODO: this error popped up when moving the checkout-instore project
            // to checkout-instore-legacy, but needs to be fixed at some point
            // @ts-ignore */}
            {intl.formatNumber(listPrice, {
              style: 'currency',
              currency: currency,
              currencyDisplay: 'code',
              minimumFractionDigits: 2,
            })}
          </span>
        </div>
      )}
      <div>
        {showLabels && (
          <div>
            <FormattedMessage id="pricing-to" />
          </div>
        )}
        {showStartingAt && (
          <span>
            <FormattedMessage id="price-starting-from" />{' '}
          </span>
        )}
        <div className={csx({ fontSize: '2.25rem', fontWeight: '700' })}>
          {intl.formatNumber(sellingPrice, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      </div>
      {differentPrices && showSavings && listPrice && (
        <div>
          <div>
            <FormattedMessage
              id="pricing-savings"
              values={{
                savings: intl.formatNumber(listPrice - sellingPrice, {
                  style: 'currency',
                  currency: currency,
                  currencyDisplay: 'code',
                  minimumFractionDigits: 2,
                }),
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
